import { useQuery } from "@apollo/react-hooks";
import { FREE_LESSONS } from "../queries";

export function useFreeLessons() {
  const { data, loading, error} = useQuery(FREE_LESSONS);

  return { data, loading, error };
}